import { render, staticRenderFns } from "./MakerComponent.vue?vue&type=template&id=cade72fc&scoped=true"
import script from "./MakerComponent.vue?vue&type=script&lang=js"
export * from "./MakerComponent.vue?vue&type=script&lang=js"
import style0 from "./MakerComponent.vue?vue&type=style&index=0&id=cade72fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../production-parity-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cade72fc",
  null
  
)

export default component.exports